import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { VaultData } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { InvestorProfileFormData } from '../types';
export const IncomeSection = () => {
  const $ = _c(52);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectInvestorProfile.income"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      label: t1,
      value: "le25k"
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      label: t3,
      value: "gt25k_le50k"
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      label: t5,
      value: "gt50k_le100k"
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      label: t7,
      value: "gt100k_le200k"
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp5);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      label: t9,
      value: "gt200k_le300k"
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      label: t11,
      value: "gt300k_le500k"
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp7);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      label: t13,
      value: "gt500k_le1200k"
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp8);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = {
      label: t15,
      value: "gt1200k"
    };
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t12 || $[35] !== t14 || $[36] !== t16 || $[37] !== t2 || $[38] !== t4 || $[39] !== t6 || $[40] !== t8) {
    t17 = [t2, t4, t6, t8, t10, t12, t14, t16];
    $[33] = t10;
    $[34] = t12;
    $[35] = t14;
    $[36] = t16;
    $[37] = t2;
    $[38] = t4;
    $[39] = t6;
    $[40] = t8;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const options = t17;
  let t18;
  if ($[42] !== t) {
    t18 = t(_temp9);
    $[42] = t;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18) {
    t19 = <h2 className="text-label-2 text-primary">{t18}</h2>;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = diToFormData("investor_profile.annual_income");
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== options) {
    t21 = <Form.RadioGroup name={t20} className="flex flex-col gap-4" options={options} />;
    $[47] = options;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t19 || $[50] !== t21) {
    t22 = <section className="flex flex-col gap-6">{t19}{t21}</section>;
    $[49] = t19;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  return t22;
};
export default IncomeSection;
function _temp($) {
  return $.le25k;
}
function _temp2($_0) {
  return $_0.gt25kLe50k;
}
function _temp3($_1) {
  return $_1.gt50kLe100k;
}
function _temp4($_2) {
  return $_2.gt100kLe200k;
}
function _temp5($_3) {
  return $_3.gt200kLe300k;
}
function _temp6($_4) {
  return $_4.gt300kLe500k;
}
function _temp7($_5) {
  return $_5.gt500kLe1200k;
}
function _temp8($_6) {
  return $_6.gt1200k;
}
function _temp9($_7) {
  return $_7.title;
}